/* eslint-disable react/no-multi-comp*/
/* eslint-disable react/jsx-no-bind */
/* global window */

import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import withLocalStorage from 'HOCs/withLocalStorage/withLocalStorage';
import withTrack from 'HOCs/withTrack/withTrack';
import { withExperiment } from 'LaquesisEOL/withExperiment';
import { EvaluationConstants } from 'olx-autos-landing-page';

import css from './AppInstallation.scss';

const EXPERIMENT_ID = 'ROAD-5022';
const HIDE_LOCAL_STORAGE_KEY = 'AppInstallationHidden';

const CircleLogo = () => (<svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.93335" y="0.933594" width="43.7333" height="43.7333" rx="21.8667" fill="white" />
    <path fillRule="evenodd" clipRule="evenodd" d="M23.6496 23.0596H26.1825V11.8672H23.6496V23.0596ZM16.163 17.7874C16.163 18.5587 16.8012 19.1839 17.5885 19.1839C18.3758 19.1839 19.014 18.5587 19.014 17.7874C19.014 17.0162 18.3758 16.391 17.5885 16.391C16.8012 16.391 16.163 17.0162 16.163 17.7874ZM12.8846 17.787C12.8846 15.2419 14.9907 13.1788 17.5887 13.1788C20.1867 13.1788 22.2928 15.2419 22.2928 17.787C22.2928 20.3321 20.1867 22.3954 17.5887 22.3954C14.9907 22.3954 12.8846 20.3321 12.8846 17.787ZM31.0282 14.9873H32.8272V16.7798L31.7861 17.7996L32.8272 18.8195V20.5871H31.0028L29.9718 19.577L28.9406 20.5871H27.1163V18.8195L28.1574 17.7996L27.1163 16.7798V14.9873H28.9153L29.9718 16.0222L31.0282 14.9873ZM12.1147 30.9578H10.9002L11.5075 29.2513L12.1147 30.9578ZM10.4222 32.3231H12.5924L13.1697 33.9321H14.9317L12.3833 27.1838H10.6313L8.22224 33.9321H9.8548L10.4222 32.3231ZM14.9216 31.2407V27.184H16.5841V31.2407C16.5841 32.0014 16.9523 32.528 17.7687 32.528C18.5551 32.528 18.9333 31.9917 18.9333 31.231V27.184H20.5958V31.231C20.5958 32.8596 19.6401 34.0591 17.7487 34.0591C15.8076 34.0591 14.9216 32.9278 14.9216 31.2407ZM23.9405 33.9323V28.7053H25.0853V27.184H21.1233V28.7053H22.2781V33.9323H23.9405ZM35.03 29.612L35.896 29.9436C36.7921 30.3044 37.3196 30.8895 37.3196 31.894C37.3196 33.2593 36.3341 34.0589 34.9504 34.0589C32.9793 34.0589 32.621 32.8009 32.6808 31.816H34.2536C34.2337 32.2451 34.4028 32.6644 34.9504 32.6644C35.3286 32.6644 35.6074 32.4597 35.6074 32.0695C35.6074 31.6892 35.3286 31.5039 34.8807 31.3382C34.8207 31.3146 34.7607 31.2914 34.7005 31.2681C34.4114 31.1562 34.1187 31.0429 33.8056 30.8895C33.1088 30.5385 32.7404 29.8754 32.7404 29.0562C32.7404 27.8762 33.6164 27.0571 34.9603 27.0571C36.583 27.0571 37.1703 27.964 37.1006 29.1635H35.5676C35.5775 28.7441 35.3585 28.4516 34.9703 28.4516C34.5921 28.4516 34.4028 28.6759 34.4028 28.9587C34.4028 29.2415 34.5621 29.4365 35.03 29.612ZM25.0951 30.5581C25.0951 28.603 26.7129 27.0182 28.7086 27.0182C30.7042 27.0182 32.3222 28.603 32.3222 30.5581C32.3222 32.5132 30.7042 34.0981 28.7086 34.0981C26.7129 34.0981 25.0951 32.5132 25.0951 30.5581ZM30.5225 30.5581C30.5225 29.5783 29.7087 28.7811 28.7084 28.7811C27.7083 28.7811 26.8944 29.5783 26.8944 30.5581C26.8944 31.538 27.7083 32.3352 28.7084 32.3352C29.7087 32.3352 30.5225 31.538 30.5225 30.5581Z" fill="#002F34" />
</svg>);

const AppInstallation = ({
    tabName,
    track,
    localStorage,
    variant,
    sellerState
}) => {
    const [isHidden, setIsHidden] = useState(localStorage.getItem(HIDE_LOCAL_STORAGE_KEY) ? localStorage.getItem(HIDE_LOCAL_STORAGE_KEY) == 'true' : false);
    const { TAB_NAME, EVALUATION_STATES } = EvaluationConstants;
    let from_tracking_data = '';

    if (tabName === TAB_NAME.BUY) {
        from_tracking_data = 'buy_landing';
    }
    else if (tabName === TAB_NAME.SELL) {
        from_tracking_data = 'sell_landing';
    }
    else if (tabName === TAB_NAME.FINANCE) {
        from_tracking_data = 'cf_landing';
    }

    if (sellerState === EVALUATION_STATES.VALUATION_DONE) {
        from_tracking_data = 'quote';
    }

    if (sellerState === EVALUATION_STATES.VALUATION_ERROR) {
        from_tracking_data = 'noquote';
    }

    useEffect(() => {
        const recoverHidden = localStorage.getItem(HIDE_LOCAL_STORAGE_KEY);

        setIsHidden(recoverHidden == 'true');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const hideComponent = () => {
        setIsHidden(true);
        localStorage.setItem(HIDE_LOCAL_STORAGE_KEY, 'true');
    };

    const closeComponent = e => {
        e.preventDefault();
        track('install_widget_click', { select_from: from_tracking_data, chosen_option: 'close', shown_at: 'footer' });
        hideComponent();
    };

    const installHandle = e => {
        e.preventDefault();
        track('install_widget_click', { select_from: from_tracking_data, chosen_option: 'install', shown_at: 'footer' });
        window.open('https://play.google.com/store/apps/details?id=com.olxautos.mx&referrer=olxmpwabottomwidget', '_blank');
        hideComponent();
    };
    const dataAutId = `appInstallation-${variant}`;
    const showComponent = variant == 'b' && (tabName === TAB_NAME.SELL ? (!sellerState || sellerState === EVALUATION_STATES.INITIAL || sellerState === EVALUATION_STATES.VALUATION_DONE || sellerState === EVALUATION_STATES.VALUATION_ERROR) : true);

    return showComponent ? (
        <div data-aut-id={ dataAutId } className={ isHidden ? css.appInstallation__hidden : css.appInstallationB__container }>
            <div className={ css.appInstallation__contentContainer }>
                <button className={ css.appInstallation__closeButton } onClick={ closeComponent }>
                    <svg
                        width={ 14 }
                        height={ 14 }
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12.724 0.333252L11.8767 1.18025L7.00001 6.05692L2.12334 1.18025L1.27601 0.333252H0.333344V1.27592L1.18068 2.12292L6.05734 6.99992L1.18068 11.8766V11.8763L0.333344 12.7239V13.6666H1.27601L2.12334 12.8193L7.00001 7.94259L11.8767 12.8193L12.724 13.6666H13.6667V12.7239L12.8197 11.8763V11.8766L7.94301 6.99992L12.8197 2.12292L13.6667 1.27592V0.333252H12.724Z"
                            fill="#fff" />
                    </svg>
                </button>
                <div className={ css.appInstallation__logo }><CircleLogo /></div>
                <div
                    className={ css.appInstallation__description }
                    allowDangerousHtml
                >Olx Autos is faster on the app. Open the
 app to get the full experience. <a title="Try the app" href="#" onClick={ installHandle }>Try the App</a>
                </div>
                <div className={ css.appInstallation__divider }><svg width="1" height="30" viewBox="0 0 1 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect y="29.3782" width="29.1556" height="0.911111" transform="rotate(-90 0 29.3782)" fill="#F2F4F5" />
                </svg>
                </div>
            </div>

        </div>
    ) : null;
};

AppInstallation.propTypes = {
    tabName: PropTypes.string,
    track: PropTypes.func.isRequired,
    variant: PropTypes.string,
    localStorage: PropTypes.shape({
        getItem: PropTypes.func.isRequired,
        setItem: PropTypes.func.isRequired
    }).isRequired,
    sellerState: PropTypes.string
};

export const AppInstallationSingleComponent = AppInstallation;

export default compose(
    withExperiment(EXPERIMENT_ID),
    withTrack,
    withLocalStorage,
    React.memo
)(AppInstallation);
